import SHBar from './src/bar.vue';


/**
 * ECharts绘制柱状图
 */

/* istanbul ignore next */
SHBar.install = function(Vue) {
  Vue.component('sh-bar', SHBar);
};
export default SHBar;


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/charts/bar/index.js